var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _rect2, _path22, _path23, _path24, _path25, _path26, _path27, _g4, _g5, _circle, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "100%",
      height: "63vh"
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: 1256.257,
    height: 493.771,
    viewBox: "0 0 1256.257 493.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16306",
    "data-name": "Grupo 16306",
    transform: "translate(-345.372 -197.24)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eltsyka1f1f8g",
    transform: "translate(481.387 165.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elf997x4fh2v4",
    transform: "translate(-136.015 11.651)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "el6a6utfdkkzi",
    d: "M685.112,217.129A4.871,4.871,0,0,1,680.241,222h0a4.716,4.716,0,0,1-4.872-4.556q0-.157,0-.315a4.871,4.871,0,0,1,4.872-4.871h0a4.871,4.871,0,0,1,4.871,4.871Z",
    transform: "translate(263.352 -116.865)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "el6a6utfdkkzi-2",
    "data-name": "el6a6utfdkkzi",
    d: "M685.112,217.129A4.871,4.871,0,0,1,680.241,222h0a4.716,4.716,0,0,1-4.872-4.556q0-.157,0-.315a4.871,4.871,0,0,1,4.872-4.871h0a4.871,4.871,0,0,1,4.871,4.871Z",
    transform: "translate(571.145 73.613)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "el6a6utfdkkzi-3",
    "data-name": "el6a6utfdkkzi",
    d: "M769.683,369.65a9.745,9.745,0,0,1-9.746,9.744h0a9.432,9.432,0,0,1-9.744-9.112c-.008-.21-.008-.422,0-.632a9.744,9.744,0,0,1,9.744-9.744h0a9.745,9.745,0,0,1,9.746,9.744Z",
    transform: "translate(132.622 -83.784)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "el6a6utfdkkzi-4",
    "data-name": "el6a6utfdkkzi",
    d: "M676.133,516.416a4.871,4.871,0,0,1-4.871,4.871h0a4.716,4.716,0,0,1-4.871-4.556q-.006-.158,0-.315a4.871,4.871,0,0,1,4.871-4.871h0a4.871,4.871,0,0,1,4.871,4.871Z",
    transform: "translate(77.166 -148.801)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "el14pli27qb6c",
    cx: 13.675,
    cy: 13.675,
    r: 13.675,
    transform: "translate(104.848 429.43)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eliqnk35zo7go",
    cx: 4.874,
    cy: 4.874,
    r: 4.874,
    transform: "translate(333.407 362.743)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eliqnk35zo7go-2",
    "data-name": "eliqnk35zo7go",
    cx: 4.874,
    cy: 4.874,
    r: 4.874,
    transform: "translate(204.252 240.674)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "elvicx7kc09h",
    cx: 10.757,
    cy: 10.757,
    r: 10.757,
    transform: "translate(0 188.878)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "elaefx61fchnc",
    d: "M885.315,236.348A15.149,15.149,0,1,1,870.166,221.2,15.434,15.434,0,0,1,885.315,236.348Z",
    transform: "translate(224.955 126.396)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "el39yikm57eq6",
    d: "M277.067,71.207a7.837,7.837,0,1,1-7.838-7.837A8.44,8.44,0,0,1,277.067,71.207Z",
    transform: "translate(-129.195 -43.386)",
    fill: "#0096a7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "el1cgrwu7d442",
    cx: 9.992,
    cy: 9.992,
    r: 9.992,
    transform: "translate(1123.972 155.401)",
    fill: "#0096a7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16305",
    "data-name": "Grupo 16305",
    transform: "translate(340.999 129.746)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    transform: "translate(262.318 84.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39990",
    "data-name": "Trazado 39990",
    d: "M408.862,172.474a78.644,78.644,0,0,1-106.62,73.477,78.645,78.645,0,0,0,0-146.905,78.645,78.645,0,0,1,106.62,73.429Z",
    transform: "translate(-271.871 -86.575)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39991",
    "data-name": "Trazado 39991",
    d: "M368.945,128.039a13.322,13.322,0,0,1,.819,11.363,32.864,32.864,0,0,0-3.692-9.742,34.4,34.4,0,0,0-6.42-8.25A13.371,13.371,0,0,1,368.945,128.039Z",
    transform: "translate(-285.609 -93.162)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39992",
    "data-name": "Trazado 39992",
    d: "M420.551,171.953a13.369,13.369,0,0,1-7.351,8.7,33.683,33.683,0,0,0,4.173-9.63,34.552,34.552,0,0,0,1.172-10.368A13.336,13.336,0,0,1,420.551,171.953Z",
    transform: "translate(-298.423 -102.553)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39993",
    "data-name": "Trazado 39993",
    d: "M413.124,240.221a13.323,13.323,0,0,1-10.642,4.029,33.833,33.833,0,0,0,8.282-6.324,34.282,34.282,0,0,0,6.051-8.49A13.385,13.385,0,0,1,413.124,240.221Z",
    transform: "translate(-295.858 -119.012)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39994",
    "data-name": "Trazado 39994",
    d: "M365.884,274.823a13.341,13.341,0,0,1-10.642,4.045,34.844,34.844,0,0,0,14.332-14.83A13.306,13.306,0,0,1,365.884,274.823Z",
    transform: "translate(-284.554 -127.292)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39995",
    "data-name": "Trazado 39995",
    d: "M391.993,205.9a13.337,13.337,0,0,1-6.917,9.036,35.008,35.008,0,0,0,4.4-20.143A13.226,13.226,0,0,1,391.993,205.9Z",
    transform: "translate(-291.693 -110.722)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39996",
    "data-name": "Trazado 39996",
    d: "M943.249,250.4a2.406,2.406,0,0,1-2.2-1.429c-4.558-10.3,21.154-28.151,48.9-40.445s58.246-19.373,62.82-9.068a2.411,2.411,0,0,1-4.414,1.942h0c-2.039-4.59-25.038-2.408-56.447,11.524s-48.5,29.483-46.545,34.09a2.391,2.391,0,0,1-1.152,3.18l-.067.03A2.353,2.353,0,0,1,943.249,250.4Z",
    transform: "translate(-424.608 -110.651)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1470",
    "data-name": "Elipse 1470",
    cx: 41.329,
    cy: 41.329,
    r: 41.329,
    transform: "translate(530.968 72.225)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39997",
    "data-name": "Trazado 39997",
    d: "M953.235,255.074c-6.548,0-10.609-1.605-12.085-5.008a2.423,2.423,0,0,1,1.219-3.2l.016-.007a2.391,2.391,0,0,1,3.18,1.152l.03.068c.642,1.445,5.008,3.306,17.35,1.187a175.621,175.621,0,0,0,39.113-12.7c31.362-13.883,48.471-29.467,46.4-34.105a2.411,2.411,0,1,1,4.414-1.942c4.558,10.3-21.154,28.151-48.9,40.445a181.38,181.38,0,0,1-40.254,13.049A62.769,62.769,0,0,1,953.235,255.074Z",
    transform: "translate(-424.707 -111.748)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39998",
    "data-name": "Trazado 39998",
    d: "M928.18,104.022l1.364,2.745a1.092,1.092,0,0,0,.819.594l3.034.449a1.092,1.092,0,0,1,.61,1.862l-2.2,2.151a1.06,1.06,0,0,0-.3.963l.513,3.017a1.091,1.091,0,0,1-1.6,1.156L927.7,115.53a1.157,1.157,0,0,0-1.028,0l-2.712,1.429a1.091,1.091,0,0,1-1.605-1.156l.513-3.017a1.027,1.027,0,0,0-.321-.963l-2.215-2.151a1.092,1.092,0,0,1,.61-1.862l3.034-.449a1.092,1.092,0,0,0,.818-.594l1.364-2.745a1.092,1.092,0,0,1,2.023,0Z",
    transform: "translate(-419.698 -88.839)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39999",
    "data-name": "Trazado 39999",
    d: "M270.427,459.03l1.4,2.745a1.137,1.137,0,0,0,.819.609l3.034.434a1.108,1.108,0,0,1,.609,1.878l-2.2,2.135a1.075,1.075,0,0,0-.305.963l.513,3.033a1.091,1.091,0,0,1-1.605,1.156l-2.713-1.428a1.058,1.058,0,0,0-1.027,0l-2.713,1.428a1.091,1.091,0,0,1-1.6-1.156l.513-3.033a1.075,1.075,0,0,0-.305-.963l-2.2-2.135a1.108,1.108,0,0,1,.61-1.878l3.034-.434a1.137,1.137,0,0,0,.818-.609l1.364-2.745a1.091,1.091,0,0,1,1.958,0Z",
    transform: "translate(-262.318 -173.807)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40000",
    "data-name": "Trazado 40000",
    d: "M784.038,616.438l1.349,2.745a1.075,1.075,0,0,0,.834.594l3.033.45a1.091,1.091,0,0,1,.594,1.861l-2.182,2.151a1.074,1.074,0,0,0-.321.963l.513,3.034a1.092,1.092,0,0,1-1.605,1.156l-2.713-1.429a1.027,1.027,0,0,0-1.011,0l-2.729,1.429a1.108,1.108,0,0,1-1.605-1.156l.53-3.034a1.126,1.126,0,0,0-.321-.963l-2.2-2.151a1.091,1.091,0,0,1,.61-1.861l3.033-.45a1.11,1.11,0,0,0,.835-.594l1.348-2.745a1.107,1.107,0,0,1,2.006,0Z",
    transform: "translate(-385.209 -211.467)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40001",
    "data-name": "Trazado 40001",
    d: "M384.317,394.994l.819,1.605a.643.643,0,0,0,.482.353l1.814.273a.642.642,0,0,1,.37,1.107l-1.316,1.284a.639.639,0,0,0-.176.578l.3,1.814a.657.657,0,0,1-.946.69l-1.605-.85a.593.593,0,0,0-.61,0l-1.605.85a.658.658,0,0,1-.963-.69l.321-1.814a.69.69,0,0,0-.192-.578l-1.316-1.284a.642.642,0,0,1,.369-1.107l1.814-.273a.642.642,0,0,0,.482-.353l.819-1.605a.642.642,0,0,1,1.14,0Z",
    transform: "translate(-290.357 -158.547)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40002",
    "data-name": "Trazado 40002",
    d: "M276.577,596.531l.8,1.6a.66.66,0,0,0,.5.37l1.814.256a.658.658,0,0,1,.546.754.651.651,0,0,1-.193.37l-1.3,1.284a.628.628,0,0,0-.192.578l.353,1.829a.642.642,0,0,1-.946.69l-1.605-.85a.673.673,0,0,0-.61,0l-1.605.85a.642.642,0,0,1-.947-.69l.305-1.8a.627.627,0,0,0-.192-.578l-1.316-1.283a.658.658,0,0,1,.369-1.124l1.814-.257a.688.688,0,0,0,.5-.369l.8-1.605a.674.674,0,0,1,1.108-.032Z",
    transform: "translate(-264.584 -206.79)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40003",
    "data-name": "Trazado 40003",
    d: "M1028.167,596.83l.819,1.605a.64.64,0,0,0,.5.353l1.813.257a.658.658,0,0,1,.353,1.124l-1.3,1.284a.639.639,0,0,0-.192.577l.305,1.8a.642.642,0,0,1-.947.69l-1.605-.85a.674.674,0,0,0-.61,0l-1.605.85a.658.658,0,0,1-.963-.69l.321-1.8a.639.639,0,0,0-.192-.577l-1.316-1.284a.658.658,0,0,1,.369-1.124l1.814-.257a.675.675,0,0,0,.5-.353l.8-1.605a.659.659,0,0,1,1.14,0Z",
    transform: "translate(-444.427 -206.849)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1471",
    "data-name": "Elipse 1471",
    cx: 2.135,
    cy: 2.135,
    r: 2.135,
    transform: "translate(185.509)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40004",
    "data-name": "Trazado 40004",
    d: "M799.209,120.744a2.135,2.135,0,1,1-2.151-2.119h.016A2.136,2.136,0,0,1,799.209,120.744Z",
    transform: "translate(-389.771 -92.496)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1472",
    "data-name": "Elipse 1472",
    cx: 2.135,
    cy: 2.135,
    r: 2.135,
    transform: "translate(174.579 193.434)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40005",
    "data-name": "Trazado 40005",
    d: "M403.924,551.538a2.135,2.135,0,1,1-2.151-2.119h.032a2.119,2.119,0,0,1,2.119,2.119Z",
    transform: "translate(-295.182 -195.583)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1473",
    "data-name": "Elipse 1473",
    cx: 2.135,
    cy: 2.135,
    r: 2.135,
    transform: "translate(551.993 225.533)",
    fill: "#e6e5e5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-2",
    transform: "translate(426.469 149.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40006",
    "data-name": "Trazado 40006",
    d: "M488.93,195.172a2.664,2.664,0,0,1-2.654-2.675,2.742,2.742,0,0,1,.038-.439l.883-5.088a1.092,1.092,0,0,0-.305-.93l-3.708-3.612a2.648,2.648,0,0,1,1.477-4.525l5.12-.739a1.073,1.073,0,0,0,.787-.577l2.279-4.639a2.664,2.664,0,0,1,4.815,0l2.279,4.639a1.075,1.075,0,0,0,.8.577l5.1.787a2.648,2.648,0,0,1,1.477,4.526l-3.756,3.5a1.042,1.042,0,0,0-.288.931l.866,5.088a2.648,2.648,0,0,1-3.852,2.793l-4.574-2.407a1.009,1.009,0,0,0-.979,0l-4.574,2.391A2.63,2.63,0,0,1,488.93,195.172Zm6.308-23.1a1.011,1.011,0,0,0-.947.577l-2.3,4.639a2.649,2.649,0,0,1-1.99,1.461l-5.12.738a1.043,1.043,0,0,0-.577,1.782l3.708,3.612a2.662,2.662,0,0,1,.754,2.359l-.866,5.088a1.043,1.043,0,0,0,1.508,1.108l4.59-2.408a2.65,2.65,0,0,1,2.456,0l4.59,2.408a1.043,1.043,0,0,0,1.589-1.043l-.867-5.088a2.713,2.713,0,0,1,.755-2.359l3.708-3.611a1.029,1.029,0,0,0,.272-1.076,1.041,1.041,0,0,0-.85-.706l-5.12-.739a2.649,2.649,0,0,1-1.991-1.461l-2.327-4.7A1.011,1.011,0,0,0,495.238,172.076Z",
    transform: "translate(-479.128 -170.424)",
    fill: "#76bc21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40007",
    "data-name": "Trazado 40007",
    d: "M488.93,195.172a2.664,2.664,0,0,1-2.654-2.675,2.742,2.742,0,0,1,.038-.439l.883-5.088a1.092,1.092,0,0,0-.305-.93l-3.708-3.612a2.648,2.648,0,0,1,1.477-4.525l5.12-.739a1.073,1.073,0,0,0,.787-.577l2.279-4.639a2.664,2.664,0,0,1,4.815,0l2.279,4.639a1.075,1.075,0,0,0,.8.577l5.1.787a2.648,2.648,0,0,1,1.477,4.526l-3.756,3.5a1.042,1.042,0,0,0-.288.931l.866,5.088a2.648,2.648,0,0,1-3.852,2.793l-4.574-2.407a1.009,1.009,0,0,0-.979,0l-4.574,2.391A2.63,2.63,0,0,1,488.93,195.172Zm6.308-23.1a1.011,1.011,0,0,0-.947.577l-2.3,4.639a2.649,2.649,0,0,1-1.99,1.461l-5.12.738a1.043,1.043,0,0,0-.577,1.782l3.708,3.612a2.662,2.662,0,0,1,.754,2.359l-.866,5.088a1.043,1.043,0,0,0,1.508,1.108l4.59-2.408a2.65,2.65,0,0,1,2.456,0l4.59,2.408a1.043,1.043,0,0,0,1.589-1.043l-.867-5.088a2.713,2.713,0,0,1,.755-2.359l3.708-3.611a1.029,1.029,0,0,0,.272-1.076,1.041,1.041,0,0,0-.85-.706l-5.12-.739a2.649,2.649,0,0,1-1.991-1.461l-2.327-4.7A1.011,1.011,0,0,0,495.238,172.076Z",
    transform: "translate(-479.128 -170.424)",
    fill: "#a01779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40008",
    "data-name": "Trazado 40008",
    d: "M876.188,350.992a4.4,4.4,0,0,1-4.341-4.454c0-.067,0-.133.007-.2l.675-9.887a2.728,2.728,0,0,0-1.028-2.327l-7.752-6.163a4.35,4.35,0,0,1,1.605-7.624l9.63-2.408a2.664,2.664,0,0,0,1.893-1.7l3.467-9.277a4.349,4.349,0,0,1,7.752-.787l5.265,8.394a2.711,2.711,0,0,0,2.2,1.284l9.9.434a4.35,4.35,0,0,1,3.21,7.126l-6.42,7.591a2.747,2.747,0,0,0-.593,2.536l2.648,9.55a4.318,4.318,0,0,1-1.284,4.4,4.366,4.366,0,0,1-4.526.8l-9.18-3.708a2.744,2.744,0,0,0-2.536.257l-8.249,5.473A4.412,4.412,0,0,1,876.188,350.992Zm8.266-45.26h-.289a2.68,2.68,0,0,0-2.3,1.766l-3.466,9.277a4.287,4.287,0,0,1-3.018,2.7l-9.63,2.407a2.744,2.744,0,0,0-1.043,4.815l7.752,6.163a4.316,4.316,0,0,1,1.605,3.692l-.674,9.886a2.68,2.68,0,0,0,1.348,2.552,2.729,2.729,0,0,0,2.889,0l8.266-5.473a4.349,4.349,0,0,1,4.012-.417l9.2,3.708a2.745,2.745,0,0,0,3.66-3.21l-2.649-9.55a4.335,4.335,0,0,1,.851-3.948l6.42-7.592a2.761,2.761,0,0,0-1.99-4.51l-9.887-.417a4.365,4.365,0,0,1-3.5-2.039l-5.248-8.394a2.7,2.7,0,0,0-2.311-1.413Z",
    transform: "translate(-569.993 -202.419)",
    fill: "#76bc21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40009",
    "data-name": "Trazado 40009",
    d: "M876.188,350.992a4.4,4.4,0,0,1-4.341-4.454c0-.067,0-.133.007-.2l.675-9.887a2.728,2.728,0,0,0-1.028-2.327l-7.752-6.163a4.35,4.35,0,0,1,1.605-7.624l9.63-2.408a2.664,2.664,0,0,0,1.893-1.7l3.467-9.277a4.349,4.349,0,0,1,7.752-.787l5.265,8.394a2.711,2.711,0,0,0,2.2,1.284l9.9.434a4.35,4.35,0,0,1,3.21,7.126l-6.42,7.591a2.747,2.747,0,0,0-.593,2.536l2.648,9.55a4.318,4.318,0,0,1-1.284,4.4,4.366,4.366,0,0,1-4.526.8l-9.18-3.708a2.744,2.744,0,0,0-2.536.257l-8.249,5.473A4.412,4.412,0,0,1,876.188,350.992Zm8.266-45.26h-.289a2.68,2.68,0,0,0-2.3,1.766l-3.466,9.277a4.287,4.287,0,0,1-3.018,2.7l-9.63,2.407a2.744,2.744,0,0,0-1.043,4.815l7.752,6.163a4.316,4.316,0,0,1,1.605,3.692l-.674,9.886a2.68,2.68,0,0,0,1.348,2.552,2.729,2.729,0,0,0,2.889,0l8.266-5.473a4.349,4.349,0,0,1,4.012-.417l9.2,3.708a2.745,2.745,0,0,0,3.66-3.21l-2.649-9.55a4.335,4.335,0,0,1,.851-3.948l6.42-7.592a2.761,2.761,0,0,0-1.99-4.51l-9.887-.417a4.365,4.365,0,0,1-3.5-2.039l-5.248-8.394a2.7,2.7,0,0,0-2.311-1.413Z",
    transform: "translate(-569.993 -202.419)",
    fill: "#a01779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40010",
    "data-name": "Trazado 40010",
    d: "M883.892,450.469l-1.316,4.943a1.781,1.781,0,0,0,.385,1.605l3.323,3.884a1.83,1.83,0,0,1-1.3,3.018l-5.1.272a1.863,1.863,0,0,0-1.461.883l-2.664,4.366a1.847,1.847,0,0,1-3.21-.305l-1.83-4.815a1.88,1.88,0,0,0-1.284-1.124l-4.975-1.187a1.83,1.83,0,0,1-.739-3.21l3.981-3.21a1.83,1.83,0,0,0,.658-1.6l-.4-5.1a1.83,1.83,0,0,1,2.809-1.605l4.3,2.777a1.874,1.874,0,0,0,1.7.161l4.719-1.974a1.846,1.846,0,0,1,2.408,2.231Z",
    transform: "translate(-570.217 -236.605)",
    fill: "#76bc21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40011",
    "data-name": "Trazado 40011",
    d: "M883.892,450.469l-1.316,4.943a1.781,1.781,0,0,0,.385,1.605l3.323,3.884a1.83,1.83,0,0,1-1.3,3.018l-5.1.272a1.863,1.863,0,0,0-1.461.883l-2.664,4.366a1.847,1.847,0,0,1-3.21-.305l-1.83-4.815a1.88,1.88,0,0,0-1.284-1.124l-4.975-1.187a1.83,1.83,0,0,1-.739-3.21l3.981-3.21a1.83,1.83,0,0,0,.658-1.6l-.4-5.1a1.83,1.83,0,0,1,2.809-1.605l4.3,2.777a1.874,1.874,0,0,0,1.7.161l4.719-1.974a1.846,1.846,0,0,1,2.408,2.231Z",
    transform: "translate(-570.217 -236.605)",
    fill: "#a01779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40012",
    "data-name": "Trazado 40012",
    d: "M492.289,459.337l-.9,3.354a1.285,1.285,0,0,0,.256,1.124l2.263,2.6a1.252,1.252,0,0,1-.882,2.055l-3.467.192a1.2,1.2,0,0,0-.979.594l-1.814,2.953a1.236,1.236,0,0,1-2.214-.192l-1.252-3.21a1.237,1.237,0,0,0-.866-.771l-3.371-.8a1.236,1.236,0,0,1-.5-2.167l2.68-2.182a1.238,1.238,0,0,0,.466-1.06l-.289-3.467a1.252,1.252,0,0,1,1.926-1.14l2.905,1.877a1.236,1.236,0,0,0,1.156.113l3.21-1.332a1.236,1.236,0,0,1,1.669,1.461Z",
    transform: "translate(-478.106 -239.005)",
    fill: "#76bc21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40013",
    "data-name": "Trazado 40013",
    d: "M492.289,459.337l-.9,3.354a1.285,1.285,0,0,0,.256,1.124l2.263,2.6a1.252,1.252,0,0,1-.882,2.055l-3.467.192a1.2,1.2,0,0,0-.979.594l-1.814,2.953a1.236,1.236,0,0,1-2.214-.192l-1.252-3.21a1.237,1.237,0,0,0-.866-.771l-3.371-.8a1.236,1.236,0,0,1-.5-2.167l2.68-2.182a1.238,1.238,0,0,0,.466-1.06l-.289-3.467a1.252,1.252,0,0,1,1.926-1.14l2.905,1.877a1.236,1.236,0,0,0,1.156.113l3.21-1.332a1.236,1.236,0,0,1,1.669,1.461Z",
    transform: "translate(-478.106 -239.005)",
    fill: "#a01779"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40014",
    "data-name": "Trazado 40014",
    d: "M851.889,498.656c-40.269,0-82.8-16.467-109.4-44.6-26.835-28.409-34.026-64.328-20.239-101.115l6,2.247c-12.84,34.395-6.163,67.939,18.907,94.47,33.85,35.823,94.695,51.857,141.481,37.284,51.809-16.05,71.9-54.281,91.339-91.2,21.764-41.344,42.259-80.394,104.854-80.394v6.42c-58.646,0-77.425,35.663-99.172,76.959-19.115,36.289-40.766,77.425-95.112,94.326A130.16,130.16,0,0,1,851.889,498.656Z",
    transform: "translate(-108.422 -55.295)",
    fill: "#003763"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40015",
    "data-name": "Trazado 40015",
    d: "M851.889,498.656c-40.269,0-82.8-16.467-109.4-44.6-26.835-28.409-34.026-64.328-20.239-101.115l6,2.247c-12.84,34.395-6.163,67.939,18.907,94.47,33.85,35.823,94.695,51.857,141.481,37.284,51.809-16.05,71.9-54.281,91.339-91.2,21.764-41.344,42.259-80.394,104.854-80.394v6.42c-58.646,0-77.425,35.663-99.172,76.959-19.115,36.289-40.766,77.425-95.112,94.326A130.16,130.16,0,0,1,851.889,498.656Z",
    transform: "translate(-108.422 -55.295)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40016",
    "data-name": "Trazado 40016",
    d: "M673.245,290.514l-2.167.85-2.006.755-4.013,1.364c-2.681.883-5.377,1.605-8.025,2.392a145.218,145.218,0,0,1-16.821,3.419,99.3,99.3,0,0,1-18.281,1,63.3,63.3,0,0,1-10.224-1.348,59.423,59.423,0,0,1-10-3.21c-12.535-5.537-21.555-14.285-28.681-23.417a107.74,107.74,0,0,1-9.342-14.445c-1.332-2.5-2.6-4.992-3.74-7.559-.577-1.284-1.123-2.584-1.6-3.884s-.963-2.584-1.525-4.141l14.253-7.046,2.167,2.729c.771.947,1.525,1.893,2.328,2.824,1.6,1.878,3.209,3.724,4.815,5.505a123.814,123.814,0,0,0,10.1,10.015,76.225,76.225,0,0,0,10.673,8.025,57.831,57.831,0,0,0,5.393,2.937,37.648,37.648,0,0,0,5.329,1.942,25.239,25.239,0,0,0,10.3.9,87.269,87.269,0,0,0,12.744-1.942c4.462-.962,9.036-2.151,13.594-3.5,2.295-.626,4.574-1.348,6.853-2.055l4.013-1.461Z",
    transform: "translate(-70.472 -36.124)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40017",
    "data-name": "Trazado 40017",
    d: "M673.245,290.514l-2.167.85-2.006.755-4.013,1.364c-2.681.883-5.377,1.605-8.025,2.392a145.218,145.218,0,0,1-16.821,3.419,99.3,99.3,0,0,1-18.281,1,63.3,63.3,0,0,1-10.224-1.348,59.423,59.423,0,0,1-10-3.21c-12.535-5.537-21.555-14.285-28.681-23.417a107.74,107.74,0,0,1-9.342-14.445c-1.332-2.5-2.6-4.992-3.74-7.559-.577-1.284-1.123-2.584-1.6-3.884s-.963-2.584-1.525-4.141l14.253-7.046,2.167,2.729c.771.947,1.525,1.893,2.328,2.824,1.6,1.878,3.209,3.724,4.815,5.505a123.814,123.814,0,0,0,10.1,10.015,76.225,76.225,0,0,0,10.673,8.025,57.831,57.831,0,0,0,5.393,2.937,37.648,37.648,0,0,0,5.329,1.942,25.239,25.239,0,0,0,10.3.9,87.269,87.269,0,0,0,12.744-1.942c4.462-.962,9.036-2.151,13.594-3.5,2.295-.626,4.574-1.348,6.853-2.055l4.013-1.461Z",
    transform: "translate(-70.472 -36.124)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40018",
    "data-name": "Trazado 40018",
    d: "M679.08,269.312s-28.537,28.04-39.258,97.038l68.436,27.028c4.109-9.068,14.445-55.4,41.73-94.967a108.836,108.836,0,0,0-20.961-12.968,310.1,310.1,0,0,0-29.1-11.492A155.889,155.889,0,0,0,679.08,269.312Z",
    transform: "translate(-90.335 -44.278)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40019",
    "data-name": "Trazado 40019",
    d: "M679.08,269.312s-28.537,28.04-39.258,97.038l68.436,27.028c4.109-9.068,14.445-55.4,41.73-94.967a108.836,108.836,0,0,0-20.961-12.968,310.1,310.1,0,0,0-29.1-11.492A155.889,155.889,0,0,0,679.08,269.312Z",
    transform: "translate(-90.335 -44.278)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40020",
    "data-name": "Trazado 40020",
    d: "M752.742,249.247c-4.815,7.608-12.455,22.053-8.86,29.837,0,0-1.974,3.419-15.889-2.119-11.363-4.526-9.71-8.025-9.71-8.025,10.047,1.428,12.5-5.473,13.433-12.519Z",
    transform: "translate(-109.09 -39.476)",
    fill: "#f9caae"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40021",
    "data-name": "Trazado 40021",
    d: "M747.541,255.941,735.1,260.194a29.647,29.647,0,0,1-1.012,4.815c3.708.866,10.047-1.076,11.877-4.607A13.34,13.34,0,0,0,747.541,255.941Z",
    transform: "translate(-112.893 -41.078)",
    fill: "#f5b69e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40022",
    "data-name": "Trazado 40022",
    d: "M607.03,396.875s-53.736,40.462-70.492,73.38C519.156,504.522,502.785,574,502.785,574l25.471,9.245s21.3-58.983,40.654-91.372c21.106-35.31,56.079-43.415,83.155-77.3Z",
    transform: "translate(-57.542 -74.803)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40023",
    "data-name": "Trazado 40023",
    d: "M607.03,396.875s-53.736,40.462-70.492,73.38C519.156,504.522,502.785,574,502.785,574l25.471,9.245s21.3-58.983,40.654-91.372c21.106-35.31,56.079-43.415,83.155-77.3Z",
    transform: "translate(-57.542 -74.803)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40024",
    "data-name": "Trazado 40024",
    d: "M658.782,409.471s-35.31,57.555-40.125,92.945c-5.216,38.744,7.175,111.643,7.175,111.643l25.359-6.083s-6.067-52.852,2.76-89.783c9.63-40.125,37.782-63.06,48.936-91.276Z",
    transform: "translate(-84.963 -77.817)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40025",
    "data-name": "Trazado 40025",
    d: "M658.782,409.471s-35.31,57.555-40.125,92.945c-5.216,38.744,7.175,111.643,7.175,111.643l25.359-6.083s-6.067-52.852,2.76-89.783c9.63-40.125,37.782-63.06,48.936-91.276Z",
    transform: "translate(-84.963 -77.817)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40026",
    "data-name": "Trazado 40026",
    d: "M776.659,307.564l1.06,1.044,1.2,1.605,2.3,3.209c1.461,2.151,2.889,4.318,4.238,6.532s2.648,4.478,3.9,6.789,2.407,4.655,3.546,7.046a116.4,116.4,0,0,1,5.874,15.135c.418,1.3.787,2.664,1.124,4.045l.53,2.054.128.513.16.739.321,1.461a42.737,42.737,0,0,1,.626,10.464,75.228,75.228,0,0,1-3.209,16.9,127.413,127.413,0,0,1-5.473,14.685c-2.055,4.687-4.334,9.181-6.757,13.579a128.746,128.746,0,0,1-8.025,12.84l-14.253-7.062c2.44-8.812,4.976-17.944,6.886-26.724.9-4.414,1.782-8.763,2.279-12.952.256-2.119.433-4.141.577-6.1a46.359,46.359,0,0,0,0-5.441,16.808,16.808,0,0,0-.77-3.8l-.113-.273v-.144l-.145-.321-.578-1.365c-.385-.9-.77-1.814-1.235-2.729q-2.651-5.68-5.858-11.074c-1.06-1.861-2.167-3.707-3.339-5.553s-2.3-3.692-3.514-5.521-2.408-3.659-3.628-5.473l-3.5-5.168Z",
    transform: "translate(-116.942 -53.431)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40027",
    "data-name": "Trazado 40027",
    d: "M776.659,307.564l1.06,1.044,1.2,1.605,2.3,3.209c1.461,2.151,2.889,4.318,4.238,6.532s2.648,4.478,3.9,6.789,2.407,4.655,3.546,7.046a116.4,116.4,0,0,1,5.874,15.135c.418,1.3.787,2.664,1.124,4.045l.53,2.054.128.513.16.739.321,1.461a42.737,42.737,0,0,1,.626,10.464,75.228,75.228,0,0,1-3.209,16.9,127.413,127.413,0,0,1-5.473,14.685c-2.055,4.687-4.334,9.181-6.757,13.579a128.746,128.746,0,0,1-8.025,12.84l-14.253-7.062c2.44-8.812,4.976-17.944,6.886-26.724.9-4.414,1.782-8.763,2.279-12.952.256-2.119.433-4.141.577-6.1a46.359,46.359,0,0,0,0-5.441,16.808,16.808,0,0,0-.77-3.8l-.113-.273v-.144l-.145-.321-.578-1.365c-.385-.9-.77-1.814-1.235-2.729q-2.651-5.68-5.858-11.074c-1.06-1.861-2.167-3.707-3.339-5.553s-2.3-3.692-3.514-5.521-2.408-3.659-3.628-5.473l-3.5-5.168Z",
    transform: "translate(-116.942 -53.431)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40028",
    "data-name": "Trazado 40028",
    d: "M655.778,668.945l-31.089,7.977-2.3-30.527,30.286-3.8Z",
    transform: "translate(-86.164 -133.601)",
    fill: "#003763"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40029",
    "data-name": "Trazado 40029",
    d: "M620.446,677.4l26.578-5.938a1.733,1.733,0,0,1,1.894,1.027l6.966,16.532a2.9,2.9,0,0,1-2.215,3.964c-7.624,1.252-11.4,1.477-20.961,3.21-5.89,1.076-17.928,3.9-26.049,5.377s-10.432-5.906-7.463-7.7c10.9-6.645,14.332-9.55,18.329-14.718A4.817,4.817,0,0,1,620.446,677.4Z",
    transform: "translate(-80.316 -140.505)",
    fill: "#003763"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40030",
    "data-name": "Trazado 40030",
    d: "M525.821,636.982l-31.2-7.576,10.336-27.895,30.511,10.753Z",
    transform: "translate(-55.589 -123.771)",
    fill: "#003763"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40031",
    "data-name": "Trazado 40031",
    d: "M491.362,631.76l26.241,7.271a1.7,1.7,0,0,1,1.188,1.782l-1.605,17.864a2.89,2.89,0,0,1-3.82,2.456c-7.319-2.471-10.753-4.045-20.03-7.014-5.7-1.814-17.654-4.976-25.5-7.5s-6.42-10.111-2.969-10.3c12.743-.738,17.142-1.685,23.1-4.366A4.822,4.822,0,0,1,491.362,631.76Z",
    transform: "translate(-47.805 -130.957)",
    fill: "#003763"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40032",
    "data-name": "Trazado 40032",
    d: "M707.276,426.987c-45.839-12.15-72.851-28.89-73.974-29.58l5.1-8.17c.257.176,27.013,16.692,71.342,28.44Z",
    transform: "translate(-88.774 -72.975)",
    fill: "#003763"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40033",
    "data-name": "Trazado 40033",
    d: "M547.992,506.353a5.861,5.861,0,0,1-2.617-.594c-2.327-1.187-3.723-3.867-3.916-7.559a26.148,26.148,0,0,1,10.721-20.993c3.082-2.007,6.083-2.456,8.41-1.268s3.74,3.868,3.932,7.543a24.306,24.306,0,0,1-2.856,11.829h0a23.452,23.452,0,0,1-8.025,9.261A10.932,10.932,0,0,1,547.992,506.353ZM557.8,475.6a10.1,10.1,0,0,0-5.393,1.861,25.808,25.808,0,0,0-10.545,20.721c.176,3.531,1.492,6.1,3.708,7.222s4.814.578,7.816-1.251a23.064,23.064,0,0,0,7.928-9.117,23.8,23.8,0,0,0,2.809-11.6c-.193-3.531-1.509-6.1-3.708-7.222A5.752,5.752,0,0,0,557.8,475.6Z",
    transform: "translate(-66.797 -93.567)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40034",
    "data-name": "Trazado 40034",
    d: "M547.992,506.353a5.861,5.861,0,0,1-2.617-.594c-2.327-1.187-3.723-3.867-3.916-7.559a26.148,26.148,0,0,1,10.721-20.993c3.082-2.007,6.083-2.456,8.41-1.268s3.74,3.868,3.932,7.543a24.306,24.306,0,0,1-2.856,11.829h0a23.452,23.452,0,0,1-8.025,9.261A10.932,10.932,0,0,1,547.992,506.353ZM557.8,475.6a10.1,10.1,0,0,0-5.393,1.861,25.808,25.808,0,0,0-10.545,20.721c.176,3.531,1.492,6.1,3.708,7.222s4.814.578,7.816-1.251a23.064,23.064,0,0,0,7.928-9.117,23.8,23.8,0,0,0,2.809-11.6c-.193-3.531-1.509-6.1-3.708-7.222A5.752,5.752,0,0,0,557.8,475.6Z",
    transform: "translate(-66.797 -93.567)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40035",
    "data-name": "Trazado 40035",
    d: "M624.139,548.319h-.385c-5.361-.434-9.132-8.282-8.394-17.495.707-8.972,5.393-16.049,10.577-16.049h.45c5.361.417,9.116,8.266,8.394,17.478C633.946,542.076,628.746,548.319,624.139,548.319Zm1.782-33.078c-4.975,0-9.485,6.853-10.175,15.617s2.888,16.643,8.025,17.061c4.43.353,9.855-5.971,10.609-15.6h0c.707-8.988-2.889-16.644-8.025-17.045Z",
    transform: "translate(-84.459 -103.016)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40036",
    "data-name": "Trazado 40036",
    d: "M624.139,548.319h-.385c-5.361-.434-9.132-8.282-8.394-17.495.707-8.972,5.393-16.049,10.577-16.049h.45c5.361.417,9.116,8.266,8.394,17.478C633.946,542.076,628.746,548.319,624.139,548.319Zm1.782-33.078c-4.975,0-9.485,6.853-10.175,15.617s2.888,16.643,8.025,17.061c4.43.353,9.855-5.971,10.609-15.6h0c.707-8.988-2.889-16.644-8.025-17.045Z",
    transform: "translate(-84.459 -103.016)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40037",
    "data-name": "Trazado 40037",
    d: "M697.633,343.761a14.537,14.537,0,0,1-5.65-1.124c-8.956-3.74-12.487-15.745-7.9-26.787a24.313,24.313,0,0,1,10.641-12.166,15.343,15.343,0,0,1,22.983,9.631,24.327,24.327,0,0,1-1.14,16.049h0a24.312,24.312,0,0,1-10.641,12.166A17.334,17.334,0,0,1,697.633,343.761Zm5.377-41.891a16.9,16.9,0,0,0-8.025,2.167,23.911,23.911,0,0,0-10.465,11.973c-4.509,10.834-1.059,22.614,7.688,26.258a15.584,15.584,0,0,0,13.594-1.076,23.909,23.909,0,0,0,10.464-11.973l.177.08-.177-.08a23.926,23.926,0,0,0,1.124-15.842,15.568,15.568,0,0,0-8.811-10.416A14.447,14.447,0,0,0,703.01,301.871Z",
    transform: "translate(-100.446 -51.959)",
    fill: "#0099b7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40038",
    "data-name": "Trazado 40038",
    d: "M697.633,343.761a14.537,14.537,0,0,1-5.65-1.124c-8.956-3.74-12.487-15.745-7.9-26.787a24.313,24.313,0,0,1,10.641-12.166,15.343,15.343,0,0,1,22.983,9.631,24.327,24.327,0,0,1-1.14,16.049h0a24.312,24.312,0,0,1-10.641,12.166A17.334,17.334,0,0,1,697.633,343.761Zm5.377-41.891a16.9,16.9,0,0,0-8.025,2.167,23.911,23.911,0,0,0-10.465,11.973c-4.509,10.834-1.059,22.614,7.688,26.258a15.584,15.584,0,0,0,13.594-1.076,23.909,23.909,0,0,0,10.464-11.973l.177.08-.177-.08a23.926,23.926,0,0,0,1.124-15.842,15.568,15.568,0,0,0-8.811-10.416A14.447,14.447,0,0,0,703.01,301.871Z",
    transform: "translate(-100.446 -51.959)",
    fill: "#0099b7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40039",
    "data-name": "Trazado 40039",
    d: "M555.638,244.362,574.3,235.2s-10.128-24.861-20.7-22.662C542.669,214.8,545.815,225.519,555.638,244.362Z",
    transform: "translate(-68.055 -30.659)",
    fill: "#003763"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40040",
    "data-name": "Trazado 40040",
    d: "M570.117,229.324l8.346,4.815s.61-17.495-3.5-18.3S569.186,219.919,570.117,229.324Z",
    transform: "translate(-73.595 -31.462)",
    fill: "#003763"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40041",
    "data-name": "Trazado 40041",
    d: "M786.893,449.937l-18.634-9.261s-13.578,23.176-5.393,30.238C771.357,478.217,777.906,469.2,786.893,449.937Z",
    transform: "translate(-119.151 -85.284)",
    fill: "#003763"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40042",
    "data-name": "Trazado 40042",
    d: "M767.3,453.2l-1.2-9.63s-14.269,10.159-12.39,13.9S760.362,459.616,767.3,453.2Z",
    transform: "translate(-117.545 -85.976)",
    fill: "#003763"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_41824",
    "data-name": "Rect\\xE1ngulo 41824",
    width: 16.066,
    height: 10.304,
    transform: "translate(657.637 286.21) rotate(-26.81)",
    fill: "#0099b7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_41825",
    "data-name": "Rect\\xE1ngulo 41825",
    width: 16.066,
    height: 10.304,
    transform: "translate(657.637 286.21) rotate(-26.81)",
    fill: "#003763"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40043",
    "data-name": "Trazado 40043",
    d: "M729.5,404.311a1.027,1.027,0,1,1,1.076-.674A.915.915,0,0,1,729.5,404.311Z",
    transform: "translate(-111.574 -76.092)",
    fill: "#0099b7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40044",
    "data-name": "Trazado 40044",
    d: "M727.764,409.575a1.027,1.027,0,1,1,.962-.454A1.027,1.027,0,0,1,727.764,409.575Z",
    transform: "translate(-111.269 -77.391)",
    fill: "#0099b7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40045",
    "data-name": "Trazado 40045",
    d: "M725.737,414.713a1.027,1.027,0,1,1,1.116-.93.98.98,0,0,1-.057.256A.9.9,0,0,1,725.737,414.713Z",
    transform: "translate(-110.67 -78.581)",
    fill: "#0099b7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40046",
    "data-name": "Trazado 40046",
    d: "M731.37,407.94a1.025,1.025,0,1,1,1.06-.674A.9.9,0,0,1,731.37,407.94Z",
    transform: "translate(-112.018 -76.96)",
    fill: "#0099b7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40047",
    "data-name": "Trazado 40047",
    d: "M729.492,413.13a1.027,1.027,0,1,1,1.117-.93,1.049,1.049,0,0,1-.057.256A.9.9,0,0,1,729.492,413.13Z",
    transform: "translate(-111.569 -78.202)",
    fill: "#0099b7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40048",
    "data-name": "Trazado 40048",
    d: "M727.757,418.389a.9.9,0,0,1-.386-1.2.787.787,0,1,1,1.445.513A.9.9,0,0,1,727.757,418.389Z",
    transform: "translate(-111.261 -79.497)",
    fill: "#0099b7"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16296",
    "data-name": "Grupo 16296",
    transform: "translate(614.133 326.17)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40049",
    "data-name": "Trazado 40049",
    d: "M729.5,404.311a1.027,1.027,0,1,1,1.076-.674A.915.915,0,0,1,729.5,404.311Z",
    transform: "translate(-725.707 -402.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40050",
    "data-name": "Trazado 40050",
    d: "M727.764,409.575a1.027,1.027,0,1,1,.962-.454A1.027,1.027,0,0,1,727.764,409.575Z",
    transform: "translate(-725.402 -403.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40051",
    "data-name": "Trazado 40051",
    d: "M725.737,414.713a1.027,1.027,0,1,1,1.116-.93.98.98,0,0,1-.057.256A.9.9,0,0,1,725.737,414.713Z",
    transform: "translate(-724.803 -404.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40052",
    "data-name": "Trazado 40052",
    d: "M731.37,407.94a1.025,1.025,0,1,1,1.06-.674A.9.9,0,0,1,731.37,407.94Z",
    transform: "translate(-726.151 -403.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40053",
    "data-name": "Trazado 40053",
    d: "M729.492,413.13a1.027,1.027,0,1,1,1.117-.93,1.049,1.049,0,0,1-.057.256A.9.9,0,0,1,729.492,413.13Z",
    transform: "translate(-725.702 -404.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40054",
    "data-name": "Trazado 40054",
    d: "M727.757,418.389a.9.9,0,0,1-.386-1.2.787.787,0,1,1,1.445.513A.9.9,0,0,1,727.757,418.389Z",
    transform: "translate(-725.394 -405.667)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16304",
    "data-name": "Grupo 16304",
    transform: "translate(614.445 145.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16297",
    "data-name": "Grupo 16297",
    transform: "translate(0 15.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40055",
    "data-name": "Trazado 40055",
    d: "M726.358,225.034c-7.974,21.326,27.954,30.272,39.122,15.731,14.274-18.584,28.353-50.811-6.037-54.845C735.775,180.855,726.358,225.034,726.358,225.034Z",
    transform: "translate(-725.214 -185.515)",
    fill: "#f9caae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16298",
    "data-name": "Grupo 16298",
    transform: "translate(13.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40056",
    "data-name": "Trazado 40056",
    d: "M777.481,195.444c-44.186-17.333-39.992-33.777-18.382-29.657a47.942,47.942,0,0,1,31.155,20.535s33.089,19.56-.007,37.961-4.2-7.673-9.067-13.782S773.916,201.175,777.481,195.444Z",
    transform: "translate(-743.324 -165.147)",
    fill: "#614a35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16299",
    "data-name": "Grupo 16299",
    transform: "translate(40.523 56.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40057",
    "data-name": "Trazado 40057",
    d: "M782.386,241.711c8.352-6.928,17.569,2.265,11.528,6.8S770.888,251.249,782.386,241.711Z",
    transform: "translate(-778.484 -239.21)",
    fill: "#f5b69e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40058",
    "data-name": "Trazado 40058",
    d: "M764.806,227.876c-.834,1.64-2.379,2.527-3.451,1.982s-1.265-2.316-.431-3.956,2.38-2.527,3.451-1.982S765.64,226.236,764.806,227.876Z",
    transform: "translate(-733.635 -179.173)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40059",
    "data-name": "Trazado 40059",
    d: "M744.541,219.186c-.834,1.64-2.379,2.528-3.451,1.982s-1.264-2.316-.431-3.956,2.379-2.528,3.451-1.982S745.375,217.546,744.541,219.186Z",
    transform: "translate(-728.786 -177.093)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16300",
    "data-name": "Grupo 16300",
    transform: "translate(11.479 59.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40060",
    "data-name": "Trazado 40060",
    d: "M740.456,242.843a34.247,34.247,0,0,1-.152,6.017c.413.132.826.263,1.243.377,5.635,1.668,8.712.939,10.416-.374a5.312,5.312,0,0,0,1.721-2.418,4.836,4.836,0,0,0,.326-1.631c-3.432.556-8.785-.672-11.624-1.426C741.193,243.082,740.456,242.843,740.456,242.843Z",
    transform: "translate(-740.304 -242.843)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40061",
    "data-name": "Trazado 40061",
    d: "M743.039,243.558l.011,1.781c5.31,1.56,9.226,2.084,11.288,1.276a4.836,4.836,0,0,0,.326-1.631C751.232,245.54,745.879,244.312,743.039,243.558Z",
    transform: "translate(-740.958 -243.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40062",
    "data-name": "Trazado 40062",
    d: "M741.938,250.858c5.635,1.668,8.712.939,10.416-.374a22.964,22.964,0,0,0-6.565-.851A6.99,6.99,0,0,0,741.938,250.858Z",
    transform: "translate(-740.695 -244.465)",
    fill: "#b74d3c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40063",
    "data-name": "Trazado 40063",
    d: "M769.968,220.784a.927.927,0,0,1-.583-.447,7.413,7.413,0,0,0-5.482-3.9.931.931,0,0,1,.127-1.858,9.236,9.236,0,0,1,6.981,4.846.93.93,0,0,1-1.042,1.356Z",
    transform: "translate(-734.264 -176.976)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40064",
    "data-name": "Trazado 40064",
    d: "M740.58,209.445a.931.931,0,0,1,.343-1.677,9.237,9.237,0,0,1,8.232,2.116.931.931,0,0,1-1.322,1.311,7.366,7.366,0,0,0-6.535-1.6A.933.933,0,0,1,740.58,209.445Z",
    transform: "translate(-728.795 -175.294)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16302",
    "data-name": "Grupo 16302",
    transform: "translate(14.823 45.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16301",
    "data-name": "Grupo 16301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40065",
    "data-name": "Trazado 40065",
    d: "M748.5,235.137a.615.615,0,0,0,.2-1.186c-1.275-.509-2.694-1.413-2.771-1.948-.005-.037-.021-.148.231-.348a11.931,11.931,0,0,0,4.009-6.161.615.615,0,0,0-1.2-.272,10.869,10.869,0,0,1-3.571,5.468,1.557,1.557,0,0,0-.687,1.491c.223,1.524,2.983,2.694,3.533,2.913A.6.6,0,0,0,748.5,235.137Z",
    transform: "translate(-744.7 -224.744)",
    fill: "#f5b69e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16303",
    "data-name": "Grupo 16303",
    transform: "translate(29.259 55.708)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1474",
    "data-name": "Elipse 1474",
    cx: 1.883,
    cy: 3.937,
    rx: 1.883,
    ry: 3.937,
    transform: "translate(0 3.594) rotate(-72.58)",
    fill: "#f5b69e"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1475",
    "data-name": "Elipse 1475",
    cx: 58.629,
    cy: 58.629,
    r: 58.629,
    transform: "translate(561.632 184.976) rotate(-45)",
    fill: "#0099b7",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40066",
    "data-name": "Trazado 40066",
    d: "M743.662,287.829a47.668,47.668,0,0,1-36.082-17.552,1.607,1.607,0,1,1,2.505-2.013,44.331,44.331,0,0,0,40.508,15.924,1.624,1.624,0,0,1,.444,3.218A47.253,47.253,0,0,1,743.662,287.829Z",
    transform: "translate(-106.464 -43.884)",
    fill: "#003763"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/Error404.b12089ba37b1567c9e715441fb1b32a5.svg";
export { ForwardRef as ReactComponent };